import { BigNumber } from "ethers";

export enum Currency {
  Eth = "eth",
  Honey = "honey",
}

export enum NftAttributeDisplayType {
  BoostNumber = "boost_number",
  BoostPercentage = "boost_percentage",
  Number = "number",
  Date = "date",
}

export interface NftAttribute {
  value: string | number;
  trait_type: string;
  display_type?: NftAttributeDisplayType;
}

export type NftMetadata = {
  name: string;
  image: string;
  description?: string;
  attributes?: NftAttribute[];
};

export type V2NftMetadata = NftMetadata & {
  hash: string;
  originalHash: string;
  traits: number[];
  originalTraits: number[];
};

export type NftVestingStats = {
  remaining: BigNumber;
  releasable: BigNumber;
  released: BigNumber;
  spent: BigNumber;
};

export type Trait = {
  tokenId: number;
  name: string;
  honeyConsumptionRequirement: BigNumber;
};

export type TraitSale = Trait & {
  price: BigNumber;
  counter: number;
  maxSupply: number;
  saleActive: boolean;
};

export type ImageSize = "256" | "512" | "full";

export type Sale = {
  minSupply: number;
  maxSupply: number;
  price: BigNumber;
  honeyReward: BigNumber;
};
